/**
 * checkExpiredToken.js
 * Written by: Alex Kasemir
 */
import jwtDecode from 'jwt-decode';

import { refreshToken } from '../refreshToken';
import { removeToken } from '../removeToken';

export const CHECK_EXPIRED_TOKEN_START = `CHECK_EXPIRED_TOKEN_START`;
export const CHECK_EXPIRED_TOKEN_SUCCESS = `CHECK_EXPIRED_TOKEN_SUCCESS`;
export const CHECK_EXPIRED_TOKEN_FAILURE = `CHECK_EXPIRED_TOKEN_FAILURE`;

export const checkExpiredTokenStart = () => ({
  type: CHECK_EXPIRED_TOKEN_START,
});

export const checkExpiredTokenSuccess = (token) => ({
  type: CHECK_EXPIRED_TOKEN_SUCCESS,
  token,
});

export const checkExpiredTokenFailure = (error) => ({
  type: CHECK_EXPIRED_TOKEN_FAILURE,
  error,
});

/**
 * Description of the checkExpiredToken action
 */
export const checkExpiredToken = (token) => {
  return async (dispatch) => {
    const decodedToken = jwtDecode(token);
    // difference in seconds
    const timeToExpired
      = (new Date(decodedToken.exp * 1000) - new Date()) / 1000;
    dispatch(checkExpiredTokenStart());

    if (timeToExpired > 0) {
      dispatch(checkExpiredTokenSuccess(token));
      try {
        await dispatch(refreshToken(token));
      } catch (e) {
        throw e;
      }
    } else {
      const error = new Error(`Token expired`);
      dispatch(checkExpiredTokenFailure(error.message));
      dispatch(removeToken());
      throw error;
    }
  };
};
